import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../environments/environment';

/**
 * Adjunta el JWT de Góndola. El gateway valida con la cookie `gondola_session`
 * o el header `Authorization: Bearer <jwt>`. Enviamos ambos:
 *  - `withCredentials` para que viaje la cookie (cuando aplica same-site),
 *  - y el Bearer leído de la cookie como fallback cross-site.
 *
 * En 401 con token presente (sesión expirada/rechazada) limpia la cookie y
 * redirige al gateway (que gestiona el login). Sin token no redirige, para no
 * romper entornos de desarrollo/demo sin sesión.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const cookies = inject(CookieService);
  const token = cookies.get(environment.GOOGLE_COOKIE);

  const authReq = req.clone({
    withCredentials: true,
    setHeaders: token ? { Authorization: `Bearer ${token}` } : {},
  });

  return next(authReq).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && err.status === 401 && token) {
        try {
          cookies.delete(environment.GOOGLE_COOKIE, '/');
        } catch {
          /* noop */
        }
        if (!sessionStorage.getItem('auth_forced_logout')) {
          sessionStorage.setItem('auth_forced_logout', '1');
          window.location.assign(environment.URL_BACKEND);
        }
      }
      return throwError(() => err);
    }),
  );
};
